import { render } from "./profile-setting.vue?vue&type=template&id=60a40a80"
import script from "./profile-setting.vue?vue&type=script&lang=js"
export * from "./profile-setting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__